module.exports = __webpack_public_path__ + "static/media/draggedAttached.0f3b21c0.png";